// src/App.js

import React, { useEffect, useState } from 'react';
import './App.css';
import BarChart from './components/BarChart';
import BarChartDay from './components/BarChartDay';
import BarChartMonth from './components/BarChartMonth';

import { format, startOfDay, endOfDay } from 'date-fns';

function App() {

  const [selectedOption, setSelectedOption] = useState('Hora');
  const [chartHeight, setChartHeight] = useState(400); // Establece la altura inicial
  const [consumo, setConsumo] = useState(0.50);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
  };

  // Obtiene la fecha actual
  const currentDate = new Date();

  // Formatea la fecha según el formato deseado
  const formattedDate = `${format(currentDate, 'MMMM dd yyyy')}, ${format(startOfDay(currentDate), 'HH:mm')} - ${format(endOfDay(currentDate), 'HH:mm')}`;

  // Formatea la fecha según el formato deseado
  // Formatea la fecha según el formato deseado
  const formattedDateConsumo = (
    <span className='text-bold'>
       12:05<br />
      {format(currentDate, 'dd MMMM yyyy')}
    </span>
  );


  const resetGraph = () =>{
    fetch('#{TourDomain}#/tour360/api3.php')
    .then(response => response.json())
    .then(data => {
        // Calculamos el nuevo valor
        console.log('reset');
    });
  }
  
 
  
  useEffect(() => {
    // Función para manejar cambios en el tamaño de la ventana
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      console.log(windowHeight)
      let newHeight = 400; // Establece un valor predeterminado
    
      // Añade condiciones para diferentes resoluciones
      if (windowHeight <= 600) {
        // Pantallas pequeñas (por ejemplo, dispositivos móviles)
        newHeight = 220; // Ajusta la altura para pantallas pequeñas
      } else if (windowHeight <= 1024) {
        // Pantallas medianas (por ejemplo, tabletas)
        newHeight = 320; // Ajusta la altura para tabletas
      } else if (windowHeight <= 1440) {
        // Pantallas más grandes (por ejemplo, laptops)
        newHeight = 400; // Ajusta la altura para laptops
      } else {
        // Pantallas muy grandes (por ejemplo, pantallas de escritorio)
        newHeight = 470; // Ajusta la altura para pantallas de escritorio
      }
      
      console.log(newHeight);
      setChartHeight(newHeight);
    };

    // Agrega un oyente de eventos para el cambio de tamaño de la ventana
    window.addEventListener('resize', handleResize);

    // Limpia el oyente de eventos cuando el componente se desmonta
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 


  useEffect(() => {
    resetGraph()
  }, []); 

  return (
    <div className="container mt-1">
       <div style={{padding:5}}>

            <div className="mb-4">
                <div className="row">
                  <div className="col-1" style={{margin:0,padding:0,textAlign:'center',alignSelf:'center'}}>
                    <img
                      src="./flash_on_16px.png"
                      alt="back"
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </div>
                  <div className="col-10" style={{marginLeft:-30,textAlign:'center'}}>
                  <span style={{color:'#667085'}}>Ubicación:</span><br/>
                    <span className="text-bold" style={{color:'#53358E',fontWeight:'bold'}}>Avenida Calle 26 No 59-51</span>
                  </div>
                  <div className="col-1" style={{margin:0,padding:0,textAlign:'center',alignSelf:'center',cursor:'pointer'}} onClick={resetGraph}>
                    <img
                      src="./power-off.png"
                      alt="back"
                      title='Apagar todo'
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </div> 
                </div> 
              <hr/>
            </div>

            <div style={{background:'#F2F4F7',borderRadius:20}}>
                <div className="row">
                  <div className="col-4">
                    <label
                      className={`text-bold custom-button ${selectedOption === 'Hora' ? 'active' : ''}`}
                      onClick={() => handleOptionChange('Hora')}
                    >
                      Hora
                    </label>
                  </div>
                  <div className="col-4">
                    <label
                      className={`text-bold custom-button ${selectedOption === 'Día' ? 'active' : ''}`}
                      onClick={() => handleOptionChange('Día')}
                    >
                      Día
                    </label>
                  </div>
                  <div className="col-4">
                    <label
                      className={`text-bold custom-button ${selectedOption === 'Mes' ? 'active' : ''}`}
                      onClick={() => handleOptionChange('Mes')}
                    >
                      Mes
                    </label>
                  </div>
                </div>
            </div>
          
            <div className="custom-calendar mt-4">
                <div className="row">
                  <div className="col-2" style={{margin:0,padding:0,textAlign:'center'}}>
                    <img
                      src="./calendar_today_24px.png"
                      alt="Calendario"
                      style={{ maxWidth: '100%', height: 'auto' }}
                    />
                  </div>
                  <div className="col-10 text-bold" style={{marginLeft:-30}}>
                    {formattedDate}
                  </div> 
                </div> 
            </div>
            
            <div className='row justify-content-center mt-4' style={{ width: '100%', maxHeight: chartHeight, height: chartHeight }}>
              {
                selectedOption=='Hora'?
                  <BarChart setConsumo={setConsumo}/>
                :selectedOption=='Día'?
                  <BarChartDay setConsumo={setConsumo}/>
                :selectedOption=='Mes'?
                  <BarChartMonth setConsumo={setConsumo}/>
                :null
              }
              
            </div>

            <div className='row mt-4'> 
              <div className='col-6 text-center'>
                <span style={{color:'#3D4350'}}> 
                    <img
                      src="./equalizer_24px.png"
                      alt="Calendario"
                      style={{ maxWidth: '100%', height: 'auto',marginRight:10 }}
                    />  
                     Ener Activa Importada 
                </span>
              </div>
              <div className='col-6 text-center'>
                <span style={{color:'#A3A9B6'}}>
                    <img
                      src="./equalizer_16px.png"
                      alt="Calendario"
                      style={{ maxWidth: '100%', height: 'auto',marginRight:10 }}
                    />  
                   Ener Activa Exportada
                </span>
              </div>
            </div>

            <div className="row mt-4">
              <span className="text-bold" style={{color:'#53358E',fontWeight:'bold'}}> 
                   En el intervalo seleccionado:
                </span>
            </div>

            <div className="custom-consumo mt-1">
                <div className="row">
                  <div className="col-6">
                    <span>

                      <img
                        src="./arrow_upward_24px.png"
                        alt="Calendario"
                        style={{ maxWidth: '100%', height: 'auto',marginRight:10 }}
                      />
                      Tu consumo <br></br> <span style={{marginLeft:22}}>más alto</span> 
                    </span>
                  </div>
                  <div className="col-6" style={{textAlign:'end'}}>
                    <span>
                      <strong className="text-bold">200 Wh</strong> a las <strong className="text-bold">{formattedDateConsumo}</strong>
                    </span>
                  </div> 
                </div> 
            </div> 

            <div className="row menu-container mt-4">
              <div className="col-4 mt-3">
                <div className="text-center">
                    <img
                      src="./inicio.png"
                      alt="Inicio"
                      className="img-fluid"
                      style={{ maxHeight: '80px' }}
                    />
                  <p className="text-bold mt-2" style={{color:'#14161B',fontWeight:'bold'}}>Inicio</p>
                </div>
              </div>
              <div className="col-4 mt-3">
                <div className="text-center">
                  <img
                     src="./blance.png"
                    alt="Balance"
                    className="img-fluid"
                    style={{ maxHeight: '80px' }}
                  />
                  <p className="mt-2" style={{color:'#667085'}}>Balance</p>
                </div>
              </div>
              <div className="col-4 mt-3">
                <div className="text-center">
                  <img
                    src="./ajuste.png"
                    alt="Ajustes"
                    className="img-fluid"
                    style={{ maxHeight: '80px' }}
                  />
                  <p className="mt-2" style={{color:'#667085'}}>Ajustes</p>
                </div>
              </div>
            </div>  

       </div>

    </div>
  );
}

export default App;
